import { NgModule } from '@angular/core';
import { AdminDashboardRoutingModule } from './admin-dashboard-routing.module';
import { AdminDashboardConfigModule } from './config/config.module';

@NgModule({
  imports: [
    AdminDashboardRoutingModule,
    AdminDashboardConfigModule,
  ],
})
export class AdminDashboardModule {}
